// extracted by mini-css-extract-plugin
export default {"wrapper":"zF-z","viewport":"AF-z","container":"BF-z","slide":"CF-z"};